import React from 'react';


function OpenAccount() {
    return (  
        <div className="row text-center my-5">
        <h1 className='fs-2'>
           Open a Zerodha account
        </h1>
        <p>Modern platforms and apps, ₹0 investments, and flat ₹20 intraday and F&O trades.</p>
        <button className='p-2 btn btn-primary fs-5' style={{width:"20%", margin:"0 auto"}}>Sign up for free</button>
        </div>
    );
}

export default OpenAccount;